import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import { APP_URL } from '../../../../config';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'CHECK_IN_OUT_RULESET',
  entryPoint: '/check-in-out-rulesets',
  collectionName: 'daily_check_in_out_rulesets',
  querySearchListing: [
    ['name'],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ name: { match: keyword } }] }),
  successMessageCreate: 'Check in/out ruleset created',
  successMessageUpdate: 'Check in/out ruleset updated',
  successMessageDelete: 'Check in/out ruleset deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/check-in-out-ruleset/triggers.js